import { render, staticRenderFns } from "./RealEstateClientsList.vue?vue&type=template&id=3b3649e8&"
import script from "./RealEstateClientsList.vue?vue&type=script&lang=js&"
export * from "./RealEstateClientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports